import * as styles from "./Blockquote.styles";
import type { ReactNode } from "react";

const Blockquote = (props: { children: ReactNode }) => {
  return <blockquote {...props} css={styles.blockQuote} />;
};

export { Blockquote };
